import { render, staticRenderFns } from "./shareProfile.vue?vue&type=template&id=2cb64859&scoped=true"
import script from "./shareProfile.vue?vue&type=script&lang=js"
export * from "./shareProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb64859",
  null
  
)

export default component.exports